
<template>
  <div>
    <tableComponents
      ref="tableComponents"
      :pagination="{
        currentPage: paginationForm.page,
        pageSize: paginationForm.page_size,
        total,
      }"
      @handleCurrentChange="handleCurrentChange"
      @handleSizeChange="handleSizeChange"
      @sendUserSearch="getSearch"
      :searchData="adnSearchData"
      :isHaveExport="false"
      @toAdd="showEditDialog"
    >
      <template v-slot:table>
        <el-table v-if="!isMobileViewport" :data="list" style="width: 100%" :border="true">
          <el-table-column prop="username" label="APP信息" align="center">
            <template v-slot="scope">
              <div class="user_user_info">
                <img :src="$fnc.getImgUrl(scope.row.app_logo)" alt="" />
                <div class="nickcname">{{ scope.row.app.app_name }}</div>
                <div class="nickcname">{{ scope.row.app.ad_str }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="username" label="快手" align="center">
            <template v-slot="scope">
              <el-descriptions :column="1" :size="'mini'">
                <el-descriptions-item label="快手开屏ID">
                  {{ scope.row.ks_splash_id }}
                </el-descriptions-item>
                <el-descriptions-item label="快手信息流ID">
                  {{ scope.row.ks_info_id }}
                </el-descriptions-item>
                <el-descriptions-item label="快手激励视频ID">
                  {{ scope.row.ks_reward_id }}
                </el-descriptions-item>
                <el-descriptions-item label="快手插屏广告ID">
                  {{ scope.row.ks_Interstitial_id }}
                </el-descriptions-item>
                <el-descriptions-item label="快手APPID">
                  {{ scope.row.ks_app_id }}
                </el-descriptions-item>
              </el-descriptions>
            </template>
          </el-table-column>

          <el-table-column prop="username" label="穿山甲" align="center">
            <template v-slot="scope">
              <el-descriptions :column="1" :size="'mini'">
                <el-descriptions-item label="穿山甲开屏ID">
                  {{ scope.row.csj_splash_id }}
                </el-descriptions-item>
                <el-descriptions-item label="穿山甲信息流ID">
                  {{ scope.row.csj_info_id }}
                </el-descriptions-item>
                <el-descriptions-item label="穿山甲激励视频ID">
                  {{ scope.row.csj_reward_id }}
                </el-descriptions-item>
                <el-descriptions-item label="穿山甲插屏广告ID">
                  {{ scope.row.csj_Interstitial_id }}
                </el-descriptions-item>
                <el-descriptions-item label="穿山甲APPID">
                  {{ scope.row.csj_app_id }}
                </el-descriptions-item>
              </el-descriptions>
            </template>
          </el-table-column>

          <el-table-column prop="username" label="腾讯" align="center">
            <template v-slot="scope">
              <el-descriptions :column="1" :size="'mini'">
                <el-descriptions-item label="腾讯开屏ID">
                  {{ scope.row.tx_splash_id }}
                </el-descriptions-item>
                <el-descriptions-item label="腾讯信息流ID">
                  {{ scope.row.tx_info_id }}
                </el-descriptions-item>
                <el-descriptions-item label="腾讯激励视频ID">
                  {{ scope.row.tx_reward_id }}
                </el-descriptions-item>
                <el-descriptions-item label="腾讯插屏广告ID">
                  {{ scope.row.tx_Interstitial_id }}
                </el-descriptions-item>
                <el-descriptions-item label="腾讯APPID">
                  {{ scope.row.tx_app_id }}
                </el-descriptions-item>
              </el-descriptions>
            </template>
          </el-table-column>

          <el-table-column prop="username" label="百度" align="center">
            <template v-slot="scope">
              <el-descriptions :column="1" :size="'mini'">
                <el-descriptions-item label="百度开屏ID">
                  {{ scope.row.bd_splash_id }}
                </el-descriptions-item>
                <el-descriptions-item label="百度信息流ID">
                  {{ scope.row.bd_info_id }}
                </el-descriptions-item>
                <el-descriptions-item label="百度激励视频ID">
                  {{ scope.row.bd_reward_id }}
                </el-descriptions-item>
                <el-descriptions-item label="百度插屏广告ID">
                  {{ scope.row.bd_Interstitial_id }}
                </el-descriptions-item>
                <el-descriptions-item label="百度APPID">
                  {{ scope.row.bd_app_id }}
                </el-descriptions-item>
              </el-descriptions>
            </template>
          </el-table-column>
          <el-table-column prop="username" label="广告位" align="center">
            <template v-slot="scope">
              <el-descriptions :column="1" :size="'mini'">
                <el-descriptions-item label="开屏ID">
                  {{ scope.row.splash_id }}
                </el-descriptions-item>
                <el-descriptions-item label="信息流ID">
                  {{ scope.row.info_id }}
                </el-descriptions-item>
                <el-descriptions-item label="激励视频ID">
                  {{ scope.row.reward_id }}
                </el-descriptions-item>
                <el-descriptions-item label="插屏广告ID">
                  {{ scope.row.interstitial_id }}
                </el-descriptions-item>
              </el-descriptions>
            </template>
          </el-table-column>
          <el-table-column prop="username" label="马甲包信息" align="center">
            <template v-slot="scope">
              <el-descriptions :column="1" :size="'mini'">
                <el-descriptions-item label="MD5">
                  {{ scope.row.md5 }}
                </el-descriptions-item>
                <el-descriptions-item label="SHA1">
                  {{ scope.row.sha1 }}
                </el-descriptions-item>
                <el-descriptions-item label="应用商店">
                  {{ scope.row.app_store }}
                </el-descriptions-item>
                <el-descriptions-item label="名称">
                  {{ scope.row.app_name }}
                </el-descriptions-item>
              </el-descriptions>
            </template>
          </el-table-column>
          <el-table-column
            prop="username"
            align="center"
            label="操作"
            :width="isMobileViewport ? 76 : 180"
            fixed="right"
          >
            <template v-slot="scope">
              <responsive-actions
                :items="adnRowActions"
                @select="handleAdnRowAction($event, scope.row)"
              />
            </template>
          </el-table-column>
        </el-table>
        <mobile-record-list
          v-else
          :rows="list"
          :title="getMobileAdnTitle"
          :subtitle="getMobileAdnSubtitle"
          :fields="mobileAdnFields"
          :actions="adnRowActions"
          @action="handleAdnRowAction"
        />
      </template>
    </tableComponents>
    <Dialog
      ref="userDialogRef"
      :formData="formData"
      dialogWidth="50%"
      @onSave="submitForm"
      :keySpan="5"
    />
    <Dialog
      ref="userShareDialogRef"
      :formData="shareFormData"
      dialogWidth="30%"
      @onSave="saveShareSubmit"
      :keySpan="3"
    />
  </div>
</template>

<script>
import { adnSearchData } from "@/assets/js/searchData";
import Dialog from "@/components/Dialog.vue";
import responsiveMixin from "@/mixins/responsive";
export default {
  mixins: [responsiveMixin],
  computed: {
    adnRowActions() {
      return [
        { key: "edit", label: "修改", type: "primary" },
        { key: "delete", label: "删除", type: "danger" },
      ];
    },
    mobileAdnFields() {
      return [
        { label: "开屏ID", key: "splash_id" },
        { label: "信息流ID", key: "info_id" },
        { label: "激励视频ID", key: "reward_id" },
        { label: "插屏广告ID", key: "interstitial_id" },
        { label: "快手APPID", key: "ks_app_id", summary: false },
        { label: "快手开屏ID", key: "ks_splash_id", summary: false },
        { label: "快手信息流ID", key: "ks_info_id", summary: false },
        { label: "快手激励视频ID", key: "ks_reward_id", summary: false },
        { label: "快手插屏ID", key: "ks_Interstitial_id", summary: false },
        { label: "穿山甲APPID", key: "csj_app_id", summary: false },
        { label: "穿山甲开屏ID", key: "csj_splash_id", summary: false },
        { label: "穿山甲信息流ID", key: "csj_info_id", summary: false },
        { label: "穿山甲激励视频ID", key: "csj_reward_id", summary: false },
        { label: "穿山甲插屏ID", key: "csj_Interstitial_id", summary: false },
        { label: "腾讯APPID", key: "tx_app_id", summary: false },
        { label: "腾讯开屏ID", key: "tx_splash_id", summary: false },
        { label: "腾讯信息流ID", key: "tx_info_id", summary: false },
        { label: "腾讯激励视频ID", key: "tx_reward_id", summary: false },
        { label: "腾讯插屏ID", key: "tx_Interstitial_id", summary: false },
        { label: "百度APPID", key: "bd_app_id", summary: false },
        { label: "百度开屏ID", key: "bd_splash_id", summary: false },
        { label: "百度信息流ID", key: "bd_info_id", summary: false },
        { label: "百度激励视频ID", key: "bd_reward_id", summary: false },
        { label: "百度插屏ID", key: "bd_Interstitial_id", summary: false },
        { label: "马甲包名称", key: "app_name", summary: false },
        { label: "应用商店", key: "app_store", summary: false },
        { label: "MD5", key: "md5", summary: false },
        { label: "SHA1", key: "sha1", summary: false },
      ];
    },
  },
  data() {
    return {
      adnSearchData: adnSearchData,
      list: [],
      queryForm: {},
      total: 0,

      formData: [
        {
          type: "select",
          key: "appid",
          option: this.$store.getters.getAppListGetter,
          placeholder: "所属APP",
          label: "APP",
        },
        {
          type: "text",
          key: "bd_splash_id",
          placeholder: "请输入bd_splash_id",
          label: "百度开屏广告ID",
        },
        {
          type: "text",
          key: "ks_splash_id",
          placeholder: "请输入ks_splash_id",
          label: "快手开屏广告ID",
        },
        {
          type: "text",
          key: "csj_splash_id",
          placeholder: "请输入csj_splash_id",
          label: "穿山甲开屏广告ID",
        },
        {
          type: "text",
          key: "tx_splash_id",
          placeholder: "请输入tx_splash_id",
          label: "腾讯开屏广告ID",
        },
        {
          type: "text",
          key: "bd_info_id",
          placeholder: "请输入bd_info_id",
          label: "百度信息流广告ID",
        },
        {
          type: "text",
          key: "ks_info_id",
          placeholder: "请输入ks_info_id",
          label: "快手信息流广告ID",
        },
        {
          type: "text",
          key: "csj_info_id",
          placeholder: "请输入csj_info_id",
          label: "穿山甲信息流广告ID",
        },
        {
          type: "text",
          key: "tx_info_id",
          placeholder: "请输入tx_info_id",
          label: "腾讯信息流广告ID",
        },
        {
          type: "text",
          key: "bd_reward_id",
          placeholder: "请输入bd_reward_id",
          label: "百度激励视频广告ID",
        },
        {
          type: "text",
          key: "ks_reward_id",
          placeholder: "请输入ks_reward_id",
          label: "快手激励视频广告ID",
        },
        {
          type: "text",
          key: "csj_reward_id",
          placeholder: "请输入csj_reward_id",
          label: "穿山甲激励视频广告ID",
        },
        {
          type: "text",
          key: "tx_reward_id",
          placeholder: "请输入tx_reward_id",
          label: "腾讯激励视频广告ID",
        },
        {
          type: "text",
          key: "bd_Interstitial_id",
          placeholder: "请输入bd_Interstitial_id",
          label: "百度插屏广告ID",
        },
        {
          type: "text",
          key: "csj_Interstitial_id",
          placeholder: "请输入csj_Interstitial_id",
          label: "穿山甲插屏广告ID",
        },
        {
          type: "text",
          key: "tx_Interstitial_id",
          placeholder: "请输入tx_Interstitial_id",
          label: "腾讯插屏广告ID",
        },
        {
          type: "text",
          key: "ks_Interstitial_id",
          placeholder: "请输入ks_Interstitial_id",
          label: "快手插屏广告ID",
        },
        {
          type: "text",
          key: "tx_app_id",
          placeholder: "请输入tx_app_id",
          label: "腾讯应用ID",
        },
        {
          type: "text",
          key: "csj_app_id",
          placeholder: "请输入csj_app_id",
          label: "穿山甲应用ID",
        },
        {
          type: "text",
          key: "bd_app_id",
          placeholder: "请输入bd_app_id",
          label: "百度应用ID",
        },
        {
          type: "text",
          key: "ks_app_id",
          placeholder: "请输入ks_app_id",
          label: "快手应用ID",
        },
        {
          type: "text",
          key: "reward_id",
          placeholder: "请输入reward_id",
          label: "激励广告位id",
        },
        {
          type: "text",
          key: "splash_id",
          placeholder: "请输入splash_id",
          label: "开屏广告位id",
        },
        {
          type: "text",
          key: "info_id",
          placeholder: "请输入info_id",
          label: "信息流广告位id",
        },
        {
          type: "text",
          key: "interstitial_id",
          placeholder: "请输入interstitial_id",
          label: "插屏广告位id",
        },
        {
          type: "text",
          key: "md5",
          placeholder: "请输入MD5",
          label: "MD5",
        },
        {
          type: "text",
          key: "sha1",
          placeholder: "请输入sha1",
          label: "SHA1",
        },
        {
          type: "text",
          key: "app_store",
          placeholder: "请输入应用商店",
          label: "应用商店",
        },
        {
          type: "text",
          key: "app_name",
          placeholder: "请输入app名称",
          label: "APP名称",
        },
      ],
      shareFormData: [
        {
          type: "text",
          key: "username",
          placeholder: "请输入用户名（选填）",
          label: "用户名",
        },
      ],
      userInfo: {},
      userId: 0,

      paginationForm: {
        page: 1,
        page_size: 10,
      },
    };
  },

  methods: {
    getMobileAdnTitle(row) {
      return (row.app && row.app.app_name) || row.app_name || `ADN #${row.id}`;
    },
    getMobileAdnSubtitle(row) {
      return (row.app && row.app.ad_str) || `ADN ID ${row.id || "--"}`;
    },
    handleAdnRowAction(key, row) {
      if (key === "edit") this.editAdn(row.id);
      if (key === "delete") this.delAdn(row.id);
    },
    loginListRef(id) {
      this.$refs.loginListRef.open(id);
    },
    editShare(id) {
      this.userId = id;
      this.$refs.userShareDialogRef.openDialog("修改推荐人");
    },
    //保存推荐人
    async saveShareSubmit(formData) {
      let params = { ...formData };
      params.id = this.userId;
      let data = await this.$api.getAdn.postSaveShare(params);
      if (data.code == 200) {
        this.getAdnList();
        this.$message.success("修改成功");
      }
    },
    async editAdn(id) {
      let data = await this.$api.getAdn.getAdnInfo({ id });
      if (data.code == 200) {
        this.$refs.userDialogRef.openDialog("编辑用户", "edit", id, data.data);
      }
    },
    async submitForm(formData) {
      let data = null;
      if (formData.id) {
        data = await this.$api.getAdn.postSaveAdnInfo(formData);
      } else {
        data = await this.$api.getAdn.postAddAdn(formData);
      }
      if (data.code == 200) {
        this.getAdnList();
        this.$message.success("操作成功");
      }
    },
    async delAdn(id) {
      this.$swal({
        title: "您确定要删除选中的ADN吗",
        text: "删除后将无法恢复，请谨慎操作！",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(async (willDelete) => {
        if (willDelete.value) {
          let data = await this.$api.getAdn.delAdn({ id });
          if (data.code == 200) {
            this.$fnc.success("删除成功");
            this.getAdnList();
          }
        }
      });
    },
    async getAdnList() {
      let { data } = await this.$api.getAdn.getAdnList({
        ...this.paginationForm,
        ...this.queryForm,
      });

      this.total = data.total;
      this.list = data.data;
    },

    handleCurrentChange(val) {
      this.paginationForm.page = val;
      this.getAdnList();
    },
    handleSizeChange(val) {
      this.paginationForm.page_size = val;
      this.getAdnList();
    },
    getSearch(e) {
      this.queryForm = e;
      this.getAdnList();
    },
    showEditDialog() {
      this.$refs.userDialogRef.openDialog("增加用户");
    },
    toUp(username) {
      this.$refs.tableComponents.clearSearch();
      this.getUserSearch({ username });
    },
    getUserSearch(obj) {
      this.paginationForm.page = 1;
      this.queryForm = obj;
      this.getAdnList();
    },
  },
  created() {
    this.getAdnList();
  },
  components: {
    Dialog,
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.user_user_info {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img {
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }
  .nickcname {
    background-color: #409eff;
    color: #fff;
    border-radius: 5px;
    width: max-content;
    padding: 0 5px;
    margin-bottom: 5px;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
}
.fx {
  justify-content: center;
  margin-top: 3px;
  .text {
    width: 60px;
    min-width: max-content;
    flex: 1;
    text-align: left;
  }
}
/deep/.el-descriptions__body {
  background-color: #ffffff00 !important;
}
</style>
